import { ModuleRegistry } from '../shared/ModuleRegistry';
export let moduleRegistry;
export function initModuleRegistry(rootStore, publicApi) {
    moduleRegistry = new ModuleRegistry(rootStore, publicApi);
    window.__moduleRegistry__ = moduleRegistry;
}
